import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './service-document-container.module.scss'

export function DemoContainer({ ...props }) {
  return (
    <div
      {...props}
      className={classNames(Styles.pointContainer, props.className)}
    >
      <div className={Styles.pointContainer__header}>
        <p className="sans-serif">demonstration</p>
        <h2>無料デモの内容</h2>
      </div>
      <ul>
        <li>タスク管理機能の操作感</li>
        <li>リアルタイムレポート機能の詳細</li>
        <li>タスクの詳細機能</li>
        <li>スケジュール機能の確認方法</li>
      </ul>
      <p className={Styles.etc}>etc ...</p>
      <div className={Styles.picture}>
        <StaticImage src="../../images/contact_image_point.png" height={312} />
      </div>
    </div>
  )
}
